export default {
    getContractorsData: function(state) {
        return state.contractorsData;
    },
    getSelectedOperations: function(state) {
        return state.contractorHistory.selectedOperations;
    },
    getSelectedDocuments: function (state) {
        return state.contractorHistory.selectedDocuments;
    },
    getSelected: function(state) {
        return state.contractorHistory.selected;
    },
    getContractorHistoryPagination: function(state) {
        return state.contractorsDataPagination
    },
    getContractorHistoryGetParams: function(state) {
        return function(index) {
            return state.contractorsDataGETParams[index]
        }
    },
}